import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimePickerComponent } from '../common/time-picker-module/time-picker/time-picker.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimePickerModalComponent } from '../common/time-picker-module/time-picker-modal/time-picker-modal.component';
import { IonSelectSearchableComponent } from '../common/ionSelectSearchable/ionSelectSearchable.component';
import { PhotoUploaderComponent } from '../common/photo-uploader/photo-uploader.component';
import { ThumbnailListComponent } from '../common/thumbnail-list/thumbnail-list.component';
import { TimeZoneAbbreviationPipe } from 'src/app/utils/pipes/time-zone-abbreviation.pipe';
import { FormatDateTimeTypePipe } from 'src/app/utils/pipes/format-date-time-type.pipe';
import { FooterButtonsComponent } from '../common/footer-buttons/footer-buttons.component';
import { LoadingWithButtonComponent } from '../common/loading-with-button/loading-with-button.component';
import { FooterButtonsSpacerComponent } from '../common/footer-buttons/footer-buttons-spacer/footer-buttons-spacer.component';
import { ImageSrcPipe } from 'src/app/utils/pipes/image-src.pipe';
import { IonSegmentBooleanDirective } from 'src/app/directives/ion-segment-boolean.directive';
import { ElapsedTimeFormatPipe } from 'src/app/utils/pipes/elapsed-time-format.pipe';
import { PullToRefreshComponent } from '../common/pull-to-refresh/pull-to-refresh.component';
import { TextAreaAutoResizeDirective } from 'src/app/directives/textarea-auto-resize.directive';
import { AutocompleteTableOverlayComponent } from '../common/autocomplete-table-overlay/autocomplete-table-overlay.component';
import { AdvancedSearchFilterComponent } from '../common/advanced-search-filter/advanced-search-filter.component';
import { SimpleModalComponent } from '../common/simple-modal/simple-modal.component';
import { IonTypeaheadComponent } from '../common/ion-typeahead/ion-typeahead.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PascalToSpacesPipe } from 'src/app/utils/pipes/pascal-to-spaces.pipe';
import { AutocompleteKeyboardNavDirective } from 'src/app/directives/autocomplete-keyboard-nav.directive';
import { ImageSelectorUiComponent } from '../common/image-selector-ui/image-selector-ui.component';
@NgModule({
  declarations: [
    FooterButtonsComponent,
    LoadingWithButtonComponent,
    TimePickerComponent,
    TimePickerModalComponent,
    IonSelectSearchableComponent,
    PhotoUploaderComponent,
    ThumbnailListComponent,
    TimeZoneAbbreviationPipe,
    FormatDateTimeTypePipe,
    ImageSrcPipe,
    FooterButtonsSpacerComponent,
    IonSegmentBooleanDirective,
    ElapsedTimeFormatPipe,
    FooterButtonsSpacerComponent,
    PullToRefreshComponent,
    FooterButtonsSpacerComponent,
    FooterButtonsSpacerComponent,
    IonTypeaheadComponent,
    SimpleModalComponent,
    AdvancedSearchFilterComponent,
    AutocompleteTableOverlayComponent,
    TextAreaAutoResizeDirective,
    AutocompleteKeyboardNavDirective,
    PascalToSpacesPipe,
    ImageSelectorUiComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    OverlayModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
],
  exports: [
    FooterButtonsComponent,
    LoadingWithButtonComponent,
    TimePickerComponent,
    TimePickerModalComponent,
    IonSelectSearchableComponent,
    PhotoUploaderComponent,
    ThumbnailListComponent,
    TimeZoneAbbreviationPipe,
    FormatDateTimeTypePipe,
    ImageSrcPipe,
    FooterButtonsSpacerComponent,
    IonSegmentBooleanDirective,
    ElapsedTimeFormatPipe,
    FooterButtonsSpacerComponent,
    PullToRefreshComponent,
    IonTypeaheadComponent,
    SimpleModalComponent,
    AdvancedSearchFilterComponent,
    AutocompleteTableOverlayComponent,
    TextAreaAutoResizeDirective,
    PascalToSpacesPipe,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    ImageSelectorUiComponent,
  ]
})
export class SharedModule { }
